import { GRAPHQL_ENDPOINT } from '@/constants/global'
import { ApolloClient, InMemoryCache } from '@apollo/client'
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs'
import possibleTypes from '../possibleTypes.json'

// Featured images use a fragment on NodeWithFeaturedImage. Apollo strips those
// fields from the query result unless this client knows Post implements it.
const client = new ApolloClient({
  link: createUploadLink({ uri: GRAPHQL_ENDPOINT }),
  cache: new InMemoryCache({
    possibleTypes
  })
})

export default client
